export const SAVINGS_TOOLTIP_CONSTANTS = {
    ALT_TEXT: "Apply payment coupon",
};
